// FreshDCMarginUpdateModal.jsx
import React, { useEffect, useState } from "react";
import { Box, Button, Grid, Stack, TextField, Divider } from "@mui/material";
import { DataGridPro, useGridApiContext } from "@mui/x-data-grid-pro";
import axios from "axios";
import { getGlobals } from "../../Configs";
import moment from "moment";
import { vRdxUserInfo } from "../../Redux/roStore";
import { fAlertToast } from "../../Utility/Utilitys";
import { confirmAlert } from "react-confirm-alert";
import { CmpButtonV2 } from "../../Component/Common/ToolBox/ToolBox";

export default function FreshDCMarginUpdateModal({
  open,
  data,
  setSelectedRow,
  setIsPopModalDataChanged,
}) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const baseURL = getGlobals().API_BASE_URL;

  function BlueEditTextField(props) {
    const { id, field, value } = props;
    const apiRef = useGridApiContext();

    const handleChange = (event) => {
      apiRef.current.setEditCellValue({ id, field, value: event.target.value });
    };

    return (
      <TextField
        fullWidth
        variant="standard"
        autoFocus
        type="number"
        value={value === 0 ? "" : value ?? ""} // 👈 if 0, show empty
        onChange={handleChange}
        InputProps={{
          sx: {
            textAlign: "right",
            justifyContent: "right",
            alignItems: "right",
          }, // blue background
        }}
      />
    );
  }

  const numFmt = (p) =>
    p?.value == null
      ? ""
      : Number(p.value).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

  const columns = [
    { field: "TRNS_ORD_ID", headerName: "Order.Id", width: 120 },
    { field: "TRNS_ID", headerName: "Trans.Id", width: 120 },
    { field: "TRNS_PARTYName", headerName: "Vendor", minWidth: 220, flex: 1 },
    { field: "ItmName", headerName: "Item.Name", minWidth: 140, flex: 1 },

    {
      field: "TRNS_QTY",
      headerName: "Qty",
      type: "number",
      width: 80,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "TRN_PACK_QTY",
      headerName: "Pack.Qty",
      type: "number",
      width: 80,
      align: "center",
      headerAlign: "center",
    },
    { field: "TRNS_UNITName", headerName: "Packing", width: 110 },

    {
      field: "TRNS_UnitRate",
      headerName: "Unit.Rate",
      type: "number",
      width: 90,
      align: "right",
      headerAlign: "right",
      valueFormatter: numFmt,
    },
    {
      field: "TRNS_NetAmt",
      headerName: "Net.Amt",
      type: "number",
      width: 90,
      align: "right",
      headerAlign: "right",
      valueFormatter: numFmt,
    },
    {
      field: "LandedCost",
      headerName: "LandedCost",
      type: "number",
      width: 90,
      align: "right",
      headerAlign: "right",
      valueFormatter: numFmt,
    },
    {
      field: "TRNS_Add_Margin_Base",
      headerName: "Base.Margin",
      type: "number",
      width: 90,
      align: "right",
      headerAlign: "right",
      valueFormatter: numFmt,
      cellClassName: "readonly-cell",
    },

    {
      field: "TRNS_Add_Margin_CTN",
      headerName: "Add.Margin",
      type: "number",
      width: 90,
      align: "right",
      headerAlign: "right",
      valueFormatter: numFmt,
      type: "number",
      editable: true,
      cellClassName: "editable-cell",
      renderEditCell: (params) => <BlueEditTextField {...params} />,
    },

    {
      field: "TRNS_Add_Margin_Net",
      headerName: "Net.Margin",
      type: "number",
      width: 90,
      align: "right",
      headerAlign: "right",
      valueFormatter: numFmt,
      cellClassName: "readonly-cell",
    },
    {
      field: "TRNS_TSR_RSP",
      headerName: "TSR.Cost",
      type: "number",
      width: 90,
      align: "right",
      headerAlign: "right",
      valueFormatter: numFmt,
      cellClassName: "readonly2-cell",
    },
    {
      field: "X_Add_Margin",
      headerName: "X_Add_M",
      type: "number",
      width: 90,
      align: "right",
      headerAlign: "right",
      valueFormatter: numFmt,
    },
  ];

  const fDetail = async () => {
    setLoading(true);

    try {
      const response = await axios.post(
        `${baseURL}PurchaseOrder/PUCNS01CONSLA_DC_RSP_GETROW`,
        {
          VocTyp: data?.A_VocTyp,
          VocNo: data?.A_VocNo,
          Type: data?.Type,
        }
      );

      if (response.status === 200) {
        setRows(response?.data?.data);
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const fPost = async () => {
    confirmAlert({
      title: "Post",
      message: "Are you sure to post this transaction?",
      buttons: [
        {
          label: "Yes",
          onClick: () => fSave(true),
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  const fSave = async (isPost) => {
    let loader = document?.getElementById("loader");

    loader.style.display = "flex";
    const vRdxUserInfoObj = vRdxUserInfo();
    try {
      const iArray = rows.map((item) => ({
        TRNS_ID: item.TRNS_ID,
        TRNS_SRNO: item.TRNS_SRNO,
        TRNS_Add_Margin_Base: item.TRNS_Add_Margin_Base,
        TRNS_Add_Margin_CTN: item.TRNS_Add_Margin_CTN,
        TRNS_Add_Margin_Net: item.TRNS_Add_Margin_Net,
        TRNS_TSR_RSP: item.TRNS_TSR_RSP,
      }));
      const response = await axios.post(
        `${baseURL}PurchaseOrder/postTransaction`,
        {
          VocTyp: data?.A_VocTyp,
          VocNo: data?.A_VocNo,
          Typ: data?.Type,
          UserCd: vRdxUserInfoObj?.UserID,
          confirmPost: isPost,
          items: iArray,
        }
      );
      if (response.status === 200) {
        fAlertToast(
          "SUCCESS",
          isPost
            ? "Transaction posted successfully."
            : "Transaction saved successfully."
        );
        if (isPost) {
          setSelectedRow((prev) => ({
            ...prev,
            DocStatus: "POST",
          }));
          setIsPopModalDataChanged(true);
        }
        fDetail();
        loader.style.display = "none";
      }
    } catch (err) {
      console.log(err);
      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "Consolidation not posted";
      fAlertToast("FAILED", msg);
      loader.style.display = "none";
    }
  };

  const processRowUpdate = (newRow, oldRow) => {
    const landedCost = parseFloat(newRow.LandedCost ?? 0);
    const addMargin = parseFloat(newRow.TRNS_Add_Margin_CTN ?? 0);
    const qty = parseFloat(newRow.TRNS_QTY ?? 0);
    const packQty = parseFloat(newRow.TRN_PACK_QTY ?? 0);

    const updatedRow = {
      ...newRow,
      TRNS_Add_Margin_Base: addMargin / packQty, // i) Margin Base
      TRNS_Add_Margin_Net: addMargin * qty, // ii) Net Margin
      TRNS_TSR_RSP: landedCost + addMargin, // iii) TSR Cost
    };

    setRows((prev) =>
      prev.map((r) => (r.id === updatedRow.id ? updatedRow : r))
    );

    return updatedRow;
  };

  console.log("rows", rows);

  useEffect(() => {
    if (open) {
      fDetail();
    }
  }, [open]);

  return (
    <Box>
      <Grid container spacing={1.5} mb={2} alignItems="center">
        <Grid item xs={12} md={4}>
          <TextField
            label="Voucher Type"
            size="small"
            fullWidth
            value={`${data?.A_VocTyp} - ${data?.VocName}`}
            InputProps={{ readOnly: true }}
            disabled
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField
            label="Voucher No"
            size="small"
            fullWidth
            value={data?.A_VocNo}
            InputProps={{ readOnly: true }}
            disabled
          />
        </Grid>
        <Grid item xs={12} md={1}>
          <TextField
            label="Date"
            size="small"
            fullWidth
            value={moment(data?.A_VocDt).format("DD/MM/YYYY")}
            InputProps={{ readOnly: true }}
            disabled
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            label="Location Code"
            size="small"
            fullWidth
            value={`${data?.A_Loc} - ${data?.LocName}`}
            InputProps={{ readOnly: true }}
            disabled
          />
        </Grid>
        <Grid item xs={12} md={1}>
          <TextField
            label="Status"
            size="small"
            fullWidth
            value={data?.DocStatus}
            InputProps={{ readOnly: true }}
            disabled
          />
        </Grid>

        <Grid item xs={12} md={1}>
          <TextField
            label="Type"
            size="small"
            value={data?.Type}
            fullWidth
            disabled
          />
        </Grid>
      </Grid>

      {/* Grid */}
      <Box
        sx={{
          height: "67vh",
        }}
      >
        <DataGridPro
          rows={rows}
          columns={columns}
          loading={loading}
          density="compact"
          editMode="cell"
          rowHeight={40}
          headerHeight={50}
          getRowId={(r) => r.id}
          processRowUpdate={processRowUpdate}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? "mui-even-row"
              : "mui-odd-row"
          }
          experimentalFeatures={{ newEditingApi: true }}
          sx={{
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#0d73bb",
              color: "white",
            },
            "& .editable-cell": {
              backgroundColor: "#edfaff",
              border: "1px solid lightgray",
            },

            "& .readonly-cell": {
              backgroundColor: "#e2f1ff",
            },

            "& .readonly2-cell": {
              backgroundColor: "#d4e9ff",
            },
            // highlight input while editing
            "& .MuiDataGrid-cell--editing": {
              backgroundColor: "#d7edff",
            },
            "& .MuiDataGrid-cell--editing .MuiInputBase-root": {
              backgroundColor: "#d7edff",
              borderRadius: 1,
            },
          }}
          hideFooter
        />
      </Box>

      {/* Footer actions */}
      <Stack direction="row" spacing={1} mt={2} justifyContent="flex-end">
        <CmpButtonV2
          xbtnName="Save"
          xOnClick={() => fSave(false)}
          xVariant="contained"
          xSize="medium"
          xDisabled={data?.DocStatus === "POST"}
        />
        <CmpButtonV2
          xbtnName="Post"
          xOnClick={fPost}
          xVariant="contained"
          xSize="medium"
          xDisabled={data?.DocStatus === "POST"}
        />
      </Stack>
    </Box>
  );
}
